class recentlyProducts extends HTMLElement {
    constructor() {
      super();
      this.recentlyViewed = [];
      this.container = document.querySelector('.recently-viewed-main');

      this.manageRecentlyViewed();
    }
    
    manageRecentlyViewed(){
      let getRecentlyViewed = localStorage.getItem("user_recently_viewed");
      if (getRecentlyViewed != null) {
        this.recentlyViewed = JSON.parse(getRecentlyViewed);        
        this.recentlyViewed.reverse();

        if(this.recentlyViewed.length > 0) this.showRecentlyViewed(this.recentlyViewed);
      }
      
      if(window.globalSpace.template == 'product'){
        const productData = window.globalSpace.product;
        let requiredData = {
          id: productData.id,
          handle: productData.handle,
          title: productData.title,
          price: productData.price,
          compared_at_price: productData.compare_at_price,
          image: productData.featured_image,
          first_available_variant: productData.variants[0].id,
          sku_id: productData.variants[0].sku,

        }
        this.addToRecentlyViewed(requiredData);
      }
    }

    showRecentlyViewed(products) {
      let recentlyViewedHTML = '';
      let totalProducts = 0;
      products.forEach(product => {
        const currentProduct = window.globalSpace.product?.id || '123';
        const currentIndex = product.id == currentProduct;
        let priceHTML = '';
        let comparePriceHTML = '';
        let discountPercentageHTML = '';

        if(product.price > 0){
          priceHTML = `<span class="price m-0 p-0 money lh-1-5 ls-0 fs-lg ${product.compare_at_price > product.price ? 'discounted-price' : ''}">${Utility.formatMoney(product.price, window.globalSpace.money_format)}</span>`;
        }if(product.compare_at_price > product.price){
          comparePriceHTML = `<span class="compare-at-price"><del class="price fs-sm text-gray-700 m-0 p-0 money d-inline-block">${Utility.formatMoney(product.compare_at_price, window.globalSpace.money_format)}</del></span>`;
          discountPercentageHTML = `<div class="discount-percentage"> <span class="discount-badge">(${Math.round((product.compare_at_price - product.price) / product.compare_at_price * 100)}%)</span></div>`;
        }

        if(currentIndex == false){
          totalProducts += 1;
          recentlyViewedHTML += ` <swiper-slide>
            <div class="card card-product card-product-style-1 text-start rounded-0 border-0">
              <div class="card-img text-center border-0 position-relative">
                <a href="/products/${product.handle}" class="d-block product-image product-link position-relative">
                <img src="${product.image ? product.image : 'https://cdn.shopify.com/s/files/1/0684/0120/1206/files/placeholder-img.svg?v=1755088738'}" alt="${product.title}">
              </a>
              <product-form class="product-form" data-format="product-card">
                <div class="">
                  <form method="post" action="/cart/add" class="form add-to-cart-btn bg-white position-absolute z-2">
                      <input type="hidden" name="id" value="${product.first_available_variant }">
                      <button type="submit" name="add" class="btn btn-primary flex-grow-1 cart-icon-btn">
                        <span class="add-text">
                          <svg aria-hidden="true" focusable="false" style="width:24px;height:24px;" class="cart-icon">
                              <use href="#icon-cart"></use>
                          </svg>
                        </span>
                        <span class="spinner-border"></span>
                      </button>
                  </form>
                </div>
              </product-form>
              </div>
              <div class="card-body bg-white ps-0 pe-0">
                <a href="/products/${product.handle}" class="d-block product-link lh-1-5 text-math-auto fs-lg fw-bold mb-1">${product.title}</a>
                <div class="price-wrapper d-flex align-items-center column-gap-1 d-flex flex-wrap">
                ${priceHTML}
                ${comparePriceHTML}
                ${discountPercentageHTML}
                </div>
                <!--<div>${product.first_available_variant }</div>-->
              </div>
              <!--<div class="product-object">${JSON.stringify(product, null, 2)}</div>-->
            </div>
          </swiper-slide>`;
        }
      });

      if(totalProducts > 0){
        let sliderHTML = `<div class="swiper-wrapper__custom tablet-fullwidth">
            <div class="custom-swiper-navigation light-arrow">
                <button class="swiper-button-prev button-prev-recent-viewed"><svg aria-hidden="true" focusable="false"><use href="#icon-arrow-left"></use></svg></button>
                <button class="swiper-button-next button-next-recent-viewed"><svg aria-hidden="true" focusable="false"><use href="#icon-arrow-right"></use></svg></button>
            </div>
            <swiper-container class="recentlyViewe--swiper"
              slides-per-view="2.2"
              space-between="10"
              loop="false"
              grabCursor="true"
              breakpoints='{
                  "560": {
                      "slidesPerView": 2.2,
                      "spaceBetween": 10
                  },
                  "768": {
                      "slidesPerView": 3.6,
                      "spaceBetween": 10
                  },
                  "992": {
                      "slidesPerView": 4,
                      "spaceBetween": 10
                  },
                  "1200": {
                      "slidesPerView": 4,
                      "spaceBetween": 10
                  }
              }'
              navigation='{
                  "nextEl": ".button-next-recent-viewed",
                  "prevEl": ".button-prev-recent-viewed"
              }'
              >
                ${recentlyViewedHTML}
              </swiper-container>
          </div>`;
        this.container.classList.remove('d-none');
        this.container.querySelector("recently-products").innerHTML = sliderHTML;
      }
    }

    addToRecentlyViewed(product) {
      const productExist = this.recentlyViewed.findIndex((x) => {
        return x.id == product.id;
      });

      if (productExist == -1) {
        this.recentlyViewed.push(product)
        localStorage.setItem(
          "user_recently_viewed",
          JSON.stringify(this.recentlyViewed)
        );
      }
    }
}
customElements.define("recently-products", recentlyProducts);